(() => {
  const callback = () => {
    if (!window.themeComponents.snippets.register('cart-free-shipping')) return;

    const updateShippingValue = (event) => {
      const { cart } = event.detail ?? {};
      if (!cart) return;

      const rate = window.free_shipping?.convert ? Shopify.currency.rate : 1;

      const selectors = {
        container: '.cart-free-shipping',
        titleRemaining: '.cart-free-shipping__title--remaining',
        titleReached: '.cart-free-shipping__title--reached',
        remainingAmount: '.cart-free-shipping__remaining-amount',
        progressBar: '.cart-free-shipping__progress-bar',
      };

      const containers = document.querySelectorAll(selectors.container);
      containers.forEach((container) => {
        const titleRemaining = container.querySelector(selectors.titleRemaining);
        const titleReached = container.querySelector(selectors.titleReached);
        const remainingAmount = container.querySelector(selectors.remainingAmount);
        const progressBar = container.querySelector(selectors.progressBar);

        const { total_price: currentTotal } = cart;
        const requiredTotal = remainingAmount?.dataset?.requiredAmount * rate;

        if (!currentTotal || !requiredTotal) return;

        const amountLeft = Math.max(requiredTotal - currentTotal, 0);
        const percentage = Math.min((currentTotal / requiredTotal) * 100, 100);
        const isReached = amountLeft <= 0;

        if (titleRemaining && titleReached && remainingAmount) {
          titleRemaining.classList.toggle('hidden', isReached);
          titleReached.classList.toggle('hidden', !isReached);

          remainingAmount.innerHTML = theme.Currency.formatMoney(
            amountLeft,
            theme.settings.moneyFormat,
          );
        }

        if (progressBar) {
          progressBar.value = percentage;
          progressBar.innerHTML = `${percentage}%`;
        }
      });
    };

    document.addEventListener('cart:markup-built', updateShippingValue);
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
